export default "__VITE_ASSET__CI2h8cs0__"